/*
 *
 * CostsShopPickerPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 02-Oct-2025
*/

import CostsShopPickerPopup from './CostsShopPickerPopupContainer'

export default CostsShopPickerPopup
